export enum MessageType {
  Init,
  Ack,
  Redir,
  Data,
}

export enum MessageStatus {
  Pending,
  Sending,
  Success,
  Error,
}

interface BaseMessage {
  id: number;
  type: MessageType;
  state: MessageStatus;
}

export interface DataMessage extends BaseMessage {
  type: MessageType.Data;
  dataKey: string;
  dataValue: string;
}

export interface RedirectMessage extends BaseMessage {
  type: MessageType.Redir;
  url: string;
}

export interface AcknowledgementMessage extends BaseMessage {
  type: MessageType.Ack;
  error?: string;
}

export interface InitMessage extends BaseMessage {
  type: MessageType.Init;
  token: string;
}

export type Message = DataMessage | RedirectMessage | AcknowledgementMessage | InitMessage;

export interface ProviderProps {
  children?: React.ReactNode | React.ReactNode[];
  onConnectionEstablished?(): void;
  autoRedirect?: boolean;
  retryInterval?: number;
  retryTimeout?: number;
}

export interface HookReturn {
  isConnectionEstablished: boolean;
  sendDataMessage(key: string, value: string): void;
  getMessage(messageId: number): Message | void;
  subscribeToMessageReceived(callback: (message: Message) => void): void;
  subscribeToDataReceived(callback: (key: string, value: string) => void): void;
  subscribeToRedirectRequested(callback: (url: string) => void): void;
}

export interface MessageSender {
  source: MessageEventSource;
  origin: string;
}

export enum MessageOrigin {
  Sent,
  Received,
}
export interface Repo {
  receivedMessages: { [id: number]: Message };
  sentMessages: { [id: number]: Message };
  currentIndex: number;
  storeMessage: (origin: MessageOrigin, message: Message) => void;
  getMessage: (id: number) => Message | undefined;
  resolveMessage: (ack: AcknowledgementMessage) => void;
  clearStore: () => void;
}

export interface Interval {
  intervalId: number;
  message: Message;
  wasStopped: boolean;
}
